import PropTypes from 'prop-types';
import React from 'react';
import { StatisticsLayout } from 'views/components';
import { statisticsActions } from 'core/Statistics';
import { useTranslation } from 'react-i18next';
import {
    BarChart,
    Card,
    Container,
    InfoList
} from 'mol-ui';
import {
    useDispatch,
    useSelector
} from 'hooks';

const LicensesGranted = ({
    tabController
}) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        licensesGranted,
        loading
    } = useSelector('statistics');

    const onFiltersChange = filters => {
        dispatch(statisticsActions.getStatisticsLicensesGranted(filters));
    };

    return (
        <StatisticsLayout
            filterPatients={ ['area', 'cost_center', 'hr_head', 'patient', 'position', 'workplace'] }
            loading={ loading }
            tabController={ tabController }
            onFiltersChange={ onFiltersChange }
        >
            <Container padding="10px">
                <InfoList
                    items={ licensesGranted }
                />
                <Card margin="10px 0px 0px 0px" padding="10px">
                    <BarChart
                        vertical
                        config={ [{ dataKey: 'days', label: t('Ausentismo') }] }
                        data={ licensesGranted.slice(1) }
                        xAxisVerticalHeight={ 100 }
                    />
                </Card>
            </Container>
        </StatisticsLayout>
    );

};

LicensesGranted.propTypes = {
    tabController: PropTypes.object
};

export default LicensesGranted;
